import React, { useState } from 'react'
/* import { makeStyles } from '@material-ui/core/styles' */
import { Container, Grid, Paper } from '@material-ui/core'
/* import clsx from 'clsx' */
import LastQuestions from '../Components/LastQuestions'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

export default function Questions(props) {
  const [loading, setLoading] = useState(true)

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper elevation={4} style={{ paddingBottom: 40 }}>
          <Container maxWidth='md'>
            <LastQuestions></LastQuestions>
          </Container>
        </Paper>
      </Grid>
    </Grid>
  )
}
